<template>
  <div class="myVirtual_wrap  chinese_container">
    <!-- <hahh /> -->
    <myHeader />
    <!-- 虚拟制作模块 -->
    <div class="banner">
      <!-- <div style="width: 100%; height: 150px"></div> -->
      <div class="banner_text">
        <p style="font-size: 72px; font-weight: 700" class="wow fadeInUp ProductTitle">
          虚拟制作 xR/VP
        </p>
        <p style="font-size: 26px; font-weight: 500; margin-top: 50px" class="wow fadeInUp TwoProductTitle">
          解锁无限空间叙事维度——以 LED 屏作为拍摄背景的空间合成技术
        </p>

        <router-link  id="cn_xr_vr_contact_us" class="callMe zIndexRelative100"
          :to="{ name: 'chCaseDemonstration', hash: '#specific-position' }">联系我们</router-link>
      </div>
    </div>



    <!-- 虚拟制作模块 -->
    <div class="create">
      <p style="font-size: 20px; font-weight: 500" class="wow fadeInUp">
        <i style="font-family: 'roboto';font-style: normal;font-weight: 500">关</i>于xR
      </p>
      <p style="
          font-size: 72px;
          font-weight: 500;
          margin: 30px 0 60px;
          color: #fff;
        " class="wow fadeInUp ProductTitle">
        虚拟制作(Virtual Production)<br />概念的应用实践
      </p>
      <p class="text default_font wow fadeInUp">
        应用于影视剧集、电视栏目以及发布会等应用场景。
        xR通过摄像机<span>实时追踪技术</span>、<span>实时渲染技术</span>、<span>多屏幕播控管理技术</span>，使<br />LED屏幕中呈现出的虚拟场景画面与屏幕前的“真实角色”在摄像机视角下保持正确<span>三点透视<span style="font-family: 'roboto';font-style: normal;font-weight: 700">关</span>系</span>，同时对于LED屏幕之外的<br />画面通过<span>“前景叠加”(AR)
          技术</span>进行实时合成，最终将“真实角色”置身于虚拟世界之中，达到<span>虚实结合</span>的视觉效果。
      </p>
<!--      <div class="clickShow">-->
<!--        <img style="" src="https://download.hecoos.com/enlightv/2025-17/16439dbd83b520749992779105addba4.png" alt="" />-->
<!--        <div class="btn_show1 wow fadeInUp" @click="showCard" :class="{ blinking: isAnimating }"></div>-->
<!--        <div class="xuxian_show1" :style="{ opacity: Card1 ? 1 : 0 }"></div>-->
<!--        <div class="btn_show2 wow fadeInUp" @click="showCard1" :class="{ blinking: isAnimating1 }"></div>-->
<!--        <div class="xuxian_show2" :style="{ opacity: Card2 ? 1 : 0 }"></div>-->

<!--        <div class="btn_show3 wow fadeInUp" @click="showCard2" :class="{ blinking: isAnimating2 }"></div>-->
<!--        <div class="xuxian_show3" :style="{ opacity: Card3 ? 1 : 0 }"></div>-->
<!--        <div class="btn_show4 wow fadeInUp" @click="showCard3" :class="{ blinking: isAnimating3 }"></div>-->
<!--        <div class="xuxian_show4" :style="{ opacity: Card4 ? 1 : 0 }"></div>-->

<!--        <div class="btn_show5 wow fadeInUp" @click="showCard4" :class="{ blinking: isAnimating4 }"></div>-->

<!--        <div class="btn_show6 wow fadeInUp" @click="showCard5" :class="{ blinking: isAnimating5 }"></div>-->

<!--        <div class="btn_show7 wow fadeInUp" @click="showCard6" :class="{ blinking: isAnimating6 }"></div>-->

<!--        <div class="btn_show8 wow fadeInUp" @click="showCard7" :class="{ blinking: isAnimating7 }"></div>-->
<!--        <div class="btn_show9 wow fadeInUp" @click="showCard8" :class="{ blinking: isAnimating8 }"></div>-->
<!--        <div class="xuxian_show9" :style="{ opacity: Card9 ? 1 : 0 }"></div>-->
<!--        <div class="btn_show10 wow fadeInUp" @click="showCard9" :class="{ blinking: isAnimating9 }"></div>-->
<!--        <div class="xuxian_show10" :style="{ opacity: Card10 ? 1 : 0 }"></div>-->
<!--        <div class="btn_show11 wow fadeInUp" @click="showCard10" :class="{ blinking: isAnimating10 }"></div>-->
<!--        <div class="xuxian_show11" :style="{ opacity: Card11 ? 1 : 0 }"></div>-->
<!--        <img :style="{-->
<!--          opacity: Card1 ? 1 : 0,-->
<!--        }" src="https://download.hecoos.com/enlightv/2025-16/43d89b1e9e23a2e97cdbfdffac1f0169.png" alt=""-->
<!--          class="card1" />-->
<!--        <img :style="{-->
<!--          opacity: Card2 ? 1 : 0,-->
<!--        }" src="https://download.hecoos.com/enlightv/2025-16/c1dced63f1711041d197f86ef6e8942e.png" alt=""-->
<!--          class="card2" />-->
<!--        <img :style="{-->
<!--          opacity: Card3 ? 1 : 0,-->
<!--        }" src="https://download.hecoos.com/enlightv/2025-16/3951a558786da9f40203e06fa1cb3423.png" alt=""-->
<!--          class="card3" />-->
<!--        <img :style="{-->
<!--          opacity: Card4 ? 1 : 0,-->
<!--        }" src="https://download.hecoos.com/enlightv/2025-16/9342798e4da441960c8aa85d330b4c57.png" alt=""-->
<!--          class="card4" />-->
<!--        <img :style="{-->
<!--          opacity: Card5 ? 1 : 0,-->
<!--        }" src="https://download.hecoos.com/enlightv/2025-16/ddfb0b900f3c45c1d87c4e98531e9b2a.png" alt=""-->
<!--          class="card5" />-->
<!--        <img :style="{-->
<!--          opacity: Card6 ? 1 : 0,-->
<!--        }" src="https://download.hecoos.com/enlightv/2025-16/feab8fbb20e1625017d740d38eaedfad.png" alt=""-->
<!--          class="card6" />-->
<!--        <img :style="{-->
<!--          opacity: Card7 ? 1 : 0,-->
<!--        }" src="https://download.hecoos.com/enlightv/2025-16/043334252fb58c3b3153de12d0ba9431.png" alt=""-->
<!--          class="card7" />-->
<!--        <img :style="{-->
<!--          opacity: Card8 ? 1 : 0,-->
<!--        }" src="https://download.hecoos.com/enlightv/2025-16/d0b24de15409366e7060e9f04069eb97.png" alt=""-->
<!--          class="card8" />-->
<!--        <img :style="{-->
<!--          opacity: Card9 ? 1 : 0,-->
<!--        }" src="https://download.hecoos.com/enlightv/2025-16/c72a8ed948cb09b442bf26ca3b270d71.png" alt=""-->
<!--          class="card9" />-->
<!--        <img :style="{-->
<!--          opacity: Card10 ? 1 : 0,-->
<!--        }" src="https://download.hecoos.com/enlightv/2025-16/8867a89a19a029465b56c2c1e4efd5c9.png" alt=""-->
<!--          class="card10" />-->
<!--        <img :style="{-->
<!--          opacity: Card11 ? 1 : 0,-->
<!--        }" src="https://download.hecoos.com/enlightv/2025-16/b76dd4bf4ef8bc26d81848d7b4f959ad.png" alt=""-->
<!--          class="card11" />-->
<!--      </div>-->
    </div>

    <div class="create_video">
      <video class="info_video"
             id="intro_video"
             muted src="https://download.hecoos.com/enlightv/2025-48/227a728fbf28de7f19e5460320ecd0c7.mp4">
      </video>
<!--      https://download.hecoos.com/enlightv/2025-47/c7f40550358e967ddde3a0d62d661a49.mp4-->
    </div>

    <!-- 变革制作模块 -->
    <div class="transformation">
      <p style="color: #b3b3b3; font-size: 20px; margin-bottom: 30px" class="wow fadeInUp">
        为什么选择虚拟制作
      </p>
      <p style="font-size: 48px; font-weight: 700; color: #fff" class="wow fadeInUp ProductTitle">
        变革您的制作
      </p>
      <test class="wow fadeInUp"></test>

      <!-- 2.5D拍摄方案模块 -->
      <div class="plan">
        <p style="font-size: 60px; font-weight: 700; margin: 20px 0 70px" class="wow fadeInUp">
          2.5D拍摄方案
        </p>
        <p style="font-size: 24px; line-height: 33px" class="wow fadeInUp">
          将2D与3D资产结合的一种场景资产构建方式，<br />用多层带透明通道的图片/动态场景内容组合表现近、中、远景不同层次景别的场景元素。<br />相比制作纯3D场景，2.5D的场景制作难度大幅降低且适配原有的三维工作流程。<br />对3D场景搭建的团队来说，是更轻便、高效的资产搭建方案。
        </p>
        <!-- <p>了解更多</p> -->
        <router-link class="more-button wow fadeInUp" to="/understand">了解更多</router-link>
      </div>
    </div>

    <!-- 应用场景模块 -->
    <div class="application">
      <p style="font-size: 60px; font-weight: 700; margin-bottom: 30px" class="wow fadeInUp ProductTitle">
        应用场景
      </p>
      <p style="color: #b8b8b8" class="wow fadeInUp">hecoos xR/VP的实际应用</p>
      <myBanner :applicationInfo="applicationInfo" class="wow fadeInUp"></myBanner>
    </div>

    <!-- 产品模块 -->
    <div class="product">
      <div class="tab">
        <p style="font-size: 36px" class="default_font wow fadeInUp">产品</p>
        <p style="font-size: 60px; font-weight: 700; margin-top: 12px" class="wow fadeInUp ProductTitle">
          您的虚拟制作工具包
        </p>
        <div class="switch" ref="switch_list">
          <!-- 为每个 span 绑定点击事件和动态类名 -->
          <span :class="{ select: currentTabIndex === 0 }" @click="selectTab(0)">
            Server-C
          </span>
          <span :class="{ select: currentTabIndex === 1 }" @click="selectTab(1)">
            Server-R
          </span>
          <span :class="{ select: currentTabIndex === 2 }" @click="selectTab(2)">
            Server-D
          </span>
          <div class="underline" :style="{
            width: underlineWidth + 'px',
            left: underlineLeft + 'px',
          }"></div>
        </div>

      </div>
      <!-- 产品内容部分 -->
      <div>
        <div class="content">
          <div class="studio" v-show="showContents[0]">
            <div class="layout">
              <img src="https://download.hecoos.com/enlightv/2025-17/04d5ec07fa899de9a432f1229ce2e14a.png" alt=""
                class="" />
              <div class="textContent">
                <p style="font-size: 48px; font-weight: 700" class="">
                  Server-C
                </p>
                <p class="p_item ">
                  作为虚拟制作拍摄流程中的“核心枢纽”，可以根据现场实际需求进行专业定制化配置，是您进行虚拟制作工作的必要选择。
                </p>
                <router-link class="know_call " :to="{ path: '/mediaServer?section=1', hash: '#tab' }">
                  了解更多 </router-link>
              </div>
            </div>
          </div>
          <div class="studio" v-show="showContents[1]">
            <div class="layout">
              <img src="https://download.hecoos.com/enlightv/2025-17/84ed7b41f8f729ee36615a27ffed63f9.png" alt=""
                class="" />
              <div class="textContent">
                <p style="font-size: 48px; font-weight: 700" class="">Server-R</p>
                <p class="p_item ">
                  面对繁重复杂的实时渲染任务时，hecoos
                  Server-R超强渲染能力亦能为虚拟内容创作者提供贴心保障。
                </p>
                <router-link class="know_call " :to="{ path: '/mediaServer?section=2', hash: '#tab' }">
                  了解更多 </router-link>
              </div>
            </div>
          </div>
          <div class="studio" v-show="showContents[2]">
            <div class="layout">
              <img src="https://download.hecoos.com/enlightv/2025-17/312c08f1ed29d3fb2bde6056292ed57a.png" alt=""
                class="" />
              <div class="textContent">
                <p style="font-size: 48px; font-weight: 700" class="">Server-D</p>
                <p class="p_item ">
                  依托 hecoos
                  工作流程，最大限度管控从展演的灵感到最终落地呈现的各个环节，从而践行“设计即实现”的产品设计理念。
                </p>
                <router-link class="know_call " :to="{ path: '/mediaServer?section=0', hash: '#tab' }">
                  了解更多 </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 我们正年轻模块 -->
    <div class="section_foundation">
      <div class="section_content">
        <p class="carousel-title wow fadeInUp">《75年我们正年轻》</p>
        <button class="watch-movie-button wow fadeInUp" @click="showVideo">
          <img src="https://download.hecoos.com/enlightv/2025-37/9d124e6eba23d44a2c6f6cd6aa75901f.svg" alt="" />
          <p style="font-size: 20px; font-weight: 700">观看影片</p>
        </button>
      </div>
      <div class="scroll_container">
        <div class="foundation_video">
          <video autoplay loop muted
                 src="https://download.hecoos.com/enlightv/2025-17/479f37c97440264c647fb58826abc891.mp4"></video>
        </div>
      </div>
    </div>
    <!-- 创意模块 -->
    <Creativity :imgUrl="imgUrl" :isColor="true" />

    <!-- 技术指南模块 -->
    <div class="guidebook">
      <div class="guidebook_layout">
        <div class="left">
          <img src="https://download.hecoos.com/enlightv/2025-17/87d4423d9f2bfcec8d5a3139b927ae0d.png" alt=""
            class="wow fadeInUp" />
        </div>
        <div class="rig">
          <p style="font-size: 48px; font-weight: 700; margin-bottom: 30px" class="wow fadeInUp">
            操作指南
          </p>
          <p class="p2_item wow fadeInUp">
            了解为什么扩展现实 (xR)
            是现场制作中新一代的终极故事讲述工具，以及使其成为可能的技术。
          </p>
          <div class="vir_call wow fadeInUp">
            <a href="https://download.hecoos.com/hecoos/hecoosGuide.pdf">下载指南</a>
          </div>
        </div>
      </div>
    </div>
    <videoPlayback v-if="showVideoPlayer" @close="handleCloseVideo" :videoUrl="videoUrl" />
    <myText :reviews="reviews" />
    <myFooter />
    <BackToTop></BackToTop>
  </div>
</template>

<script>
import myHeader from "@/components/pc/myHeader.vue";
import myFooter from "@/components/pc/myFooter.vue";
// import hahh from "@/components/pc/13.vue";
import Creativity from "@/components/pc/creativity";
import myBanner from "@/components/pc/myBanner";
import BackToTop from "@/components/pc/BackToTop";
import test from "@/components/pc/test.vue";
import videoPlayback from "@/components/pc/videoPlayback.vue";
import myText from "@/components/pc/myText.vue";

import Swiper from "swiper";
import "swiper/css/swiper.min.css";

export default {
  data() {
    return {
      isAnimating: true,
      isAnimating1: true,
      isAnimating2: true,
      isAnimating3: true,
      isAnimating4: true,
      isAnimating5: true,
      isAnimating6: true,
      isAnimating7: true,
      isAnimating8: true,
      isAnimating9: true,
      isAnimating10: true,
      underlineWidth: 0,
      underlineLeft: 0,
      imgUrl: 'https://download.hecoos.com/enlightv/2025-17/70a8a0bd16927f414fc5369552198623.png',
      showVideoPlayer: false,
      videoUrl: "https://download.hecoos.com/enlightv/2025-11/3682ee8f4d99851fede9ebb32b9f1b10.mp4",
      // bannerList: [
      //   { url: 'https://download.hecoos.com/enlightv/2025-17/718decc418a0bd5a7d8ee9b25003372b.png' },
      //   { url: 'https://download.hecoos.com/enlightv/2025-17/718decc418a0bd5a7d8ee9b25003372b.png' },
      // ],
      // 新增变量，用于记录当前选中的 tab 索引
      currentTabIndex: 0,
      // 新增数组，用于控制每个产品内容的显示状态
      showContents: [true, false, false, false],
      applicationInfo: [
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/ee5f23b3104fb4be10721778c0a997c4.png',
          title: "电影电视剧",
          msg: "创建奇幻的三维故事场景，用虚拟与现实场景的实时融合手段讲故事，后期前置的工作流程为导演提供直观的拍摄效果预览。",
        },
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/a25155afdd5ee47a4ce313ed0edb8797.png',
          title: "TVC广告",
          msg: "快速构建广告创意所需的拍摄空间，实现创意的高效呈现。",
        },
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/ad529ec82ee802875c26931e8fe7264e.png',
          title: "广播电视栏目",
          msg: "hecoos通过虚拟特效包装、精准导播切换、灯光与节目内容联动、视音频播放控制这几个关键环节的一体化流程，为广播电视栏目制作带来了高效有序的全新体验。",
        },
      ],
      Card1: false,
      Card2: false,
      Card3: false,
      Card4: false,
      Card5: false,
      Card6: false,
      Card7: false,
      Card8: false,
      Card9: false,
      Card10: false,
      Card11: false,
      reviews: [
        {
          content:
            "hecoos xR虚拟制片系统紧密贴合“后期前置”的创新制片流程，从源头上解决几乎所有可能出现的问题，自动化的色彩校准、定位跟踪等技术手段省时省心，高度集成化的系统对使用者而言降低了技术门槛，上手快，易操作。",
          author: "刘畅",
          position: "戏剧与影视学院虚拟制片实验中心副主任",
          institution: "南京艺术学院 戏剧与影视学院",
        },
        {
          content:
            "《流浪者号》是中国科幻题材电影在制作方式上的全新尝试。一部90分钟体量的影片仅用时12天便完成了所有拍摄工作，这在科幻题材电影制作中也是一个不小的奇迹，hecoos的虚拟拍摄流程为更加高效的摄制和惊艳的视觉呈现提供了保障，使整个制片过程非常顺畅，证明了虚拟拍摄技术在科幻题材电影中的巨大潜力。",
          author: "邹杰",
          position: "《流浪者号》制片人",
          institution: "",
        },
      ],
      is_video_play:false
    };
  },
  components: {
    myHeader,
    myFooter,
    Creativity,
    myBanner,
    BackToTop,
    test,
    videoPlayback,
    myText,
    // hahh
  },
  mounted() {
    new Swiper(this.$refs.swiper, {
      autoplay: {
        delay: 5000,
        // 交互后保持自动播放
        disableOnInteraction: true,
      },
      pagination: {
        el: ".swiper-pagination",
        // 可点击
        clickable: true,
      },
      // 禁用滑动
      allowTouchMove: false,
    });
    this.$nextTick(() => {
      this.updateUnderlinePosition();
      this.setupSpanResizeObservers();
      window.addEventListener('resize', this.updateUnderlinePosition);
    });
    window.addEventListener('scroll', this.scrollVideoPlay);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateUnderlinePosition);
    window.removeEventListener('scroll', this.scrollVideoPlay);
  },
  methods: {
    scrollVideoPlay() {
      if(this.is_video_play){return false}
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const intro_video = document.getElementById('intro_video')
      if(intro_video ){
        if (scrollTop >= intro_video.offsetTop - intro_video.offsetHeight && scrollTop < intro_video.offsetTop + intro_video.offsetHeight) {
          this.is_video_play = true
          intro_video.play()
        }
      }
    },
    showCard() {
      this.Card1 = !this.Card1;
      this.isAnimating = false;
    },
    showCard1() {
      this.Card2 = !this.Card2;
      this.isAnimating1 = false;
    },
    showCard2() {
      this.Card3 = !this.Card3;
      this.isAnimating2 = false;
    },
    showCard3() {
      this.Card4 = !this.Card4;
      this.isAnimating3 = false;
    },
    showCard4() {
      this.Card5 = !this.Card5;
      this.isAnimating4 = false;
    },
    showCard5() {
      this.Card6 = !this.Card6;
      this.isAnimating5 = false;
    },
    showCard6() {
      this.Card7 = !this.Card7;
      this.isAnimating6 = false;
    },
    showCard7() {
      this.Card8 = !this.Card8;
      this.isAnimating7 = false;
    },
    showCard8() {
      this.Card9 = !this.Card9;
      this.isAnimating8 = false;
    },
    showCard9() {
      this.Card10 = !this.Card10;
      this.isAnimating9 = false;
    },
    showCard10() {
      this.Card11 = !this.Card11;
      this.isAnimating10 = false;
    },
    // 新增方法，用于处理 tab 切换
    selectTab(index) {
      this.currentTabIndex = index;
      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[index] = true;
      this.updateUnderlinePosition();
    },
    // goVedio() {
    //   window.open(
    //     "https://download.hecoos.com/enlightv/2025-11/3682ee8f4d99851fede9ebb32b9f1b10.mp4"
    //   );
    // },
    // 显示视频播放器
    showVideo() {
      this.showVideoPlayer = true;
      document.body.style.overflow = 'hidden'; // 禁止页面滚动
    },
    // 处理关闭视频
    handleCloseVideo() {
      this.showVideoPlayer = false;
      document.body.style.overflow = 'auto'; // 恢复页面滚动
    },
    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("span")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        // 计算去除 padding 后的左侧偏移量
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },
    // 文字宽度变化监听
    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("span");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },

  },

};
</script>
<style scoped lang="scss">
@import "@/styles/optimize_adaptation.scss";
/* 虚拟制作模块 */
@import "@/styles/xty.scss";

.underline {
  position: absolute;
  bottom: 0;
  height: 3px;
  background-color: #7948ea;
  transition: all 0.3s ease;
}
.callMe {
      display: block;
      text-decoration: none;
      color: #fff;
      width: 151px;
      height: 50px;
      line-height: 50px;
      border-radius: 25px;
      background-color: #147cf5;
      margin: 0 auto;
      margin-top: 100px;
      font-size: 20px;
      transition: all 0.3s ease;
      cursor: pointer;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #147cf5;
    }
</style>
